import React from 'react';
import {
  XYPlot,
  VerticalBarSeries,
  XAxis,
  makeWidthFlexible,
  LabelSeries,
} from 'react-vis';

const FlexibleXYPlots = makeWidthFlexible(XYPlot);

function myFormatter(t,i) {
  const splitted = t.split(' ')
  return (<tspan>
    {
      splitted.map(a => <tspan x="0" dy="1em">{a}</tspan>)
    }    
  </tspan>);
}

export default function({ data, colorRange, className }) {
  const maxYDomain = data.length
    ? Math.max(...data.map(({ valid_votes_pct }) => valid_votes_pct)) + 3
    : 30;

  const processed = data
    .filter(({ valid_votes_pct }) => valid_votes_pct >= 3)
    .map(({ custom_abbreviation, valid_votes_pct, id }) => {
      return {
        color: valid_votes_pct >= 5 ? id - 1 : colorRange.length - 1,
        x: custom_abbreviation,
        y: valid_votes_pct,
        label: `${valid_votes_pct}%`,
        yOffset: -10,
        style: {
          fontSize: 12,
          fontWeight: '600'
        },
      };
    });

  return (
      <FlexibleXYPlots
        colorRange={colorRange}
        colorDomain={colorRange.map((d, i) => i)}
        height="300"
        colorScale="category"
        xType="ordinal"
        yDomain={[0, maxYDomain]}
        className={className}
      >
        <XAxis style={{ fontSize: '10px', text: {stroke: 'none', fill: '#6b6b76', fontWeight: 600} }} tickFormat={myFormatter}/>
        <VerticalBarSeries
          className=""
          data={processed}
          stack={false}
          barWidth={0.7}
        />
        <LabelSeries
          data={processed}
          animation
          labelAnchorX="middle"
          labelAnchorY="middle"
        />
      </FlexibleXYPlots>
  );
}



// WEBPACK FOOTER //
// ./src/ui/src/component/electionWidget/verticalBarChart.js